<div class="banner card">
	<div class="banner-icon">
		<img [src]="iconSrc" alt="Logo" />
	</div>
	<div class="banner-text">
		<h3 class="banner-headline">{{ translationKeyPrefix + "_title" | translate: [value] }}</h3>
		<p class="banner-description">
			{{ translationKeyPrefix + "_description" | translate: [value] }}
		</p>
	</div>
	<div class="banner-action">
		<button
			class="btn btn-primary"
			[ngClass]="{
				'btn-inverse': actionBtnType === 'inverse'
			}"
			(click)="actionClicked.emit()">
			{{ translationKeyPrefix + "_button" | translate }}
		</button>
	</div>
</div>
